module.exports = __webpack_public_path__ + "img/prize-hotpot.b976c236.png";